import { render, staticRenderFns } from "./ProfilePhoto.vue?vue&type=template&id=1637ff86&scoped=true&"
import script from "./ProfilePhoto.vue?vue&type=script&lang=js&"
export * from "./ProfilePhoto.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePhoto.vue?vue&type=style&index=0&id=1637ff86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1637ff86",
  null
  
)

export default component.exports